import _ from 'lodash';
import { Model } from 'backbone';
import moment from "moment";

const bye_rounds_ids = JSON.parse(process.env.BYE_ROUNDS || '[]');

export default class Round extends Model {

	get next_match() {
		const
			matches = this.get('matches'),
			predicate = { status: 'scheduled' },
			next_match = _.find(matches, predicate);

		return next_match || {};
	}

	get active_match() {
		const
			matches = this.get('matches'),
			predicate = { status: 'playing' },
			active_match = _.find(matches, predicate);

		return active_match || {};
	}

	get actual_match() {
		const
			matches = this.get('matches'),
			statuses = ['playing', 'scheduled'],
			actual_match = _.find(matches, match => statuses.includes(match.status));

		return actual_match || _.last(matches);
	}

	get is_match_active() {
		return !_.isEmpty(this.active_match);
	}

	get is_full_lockout(){
		return this.get('matches').every(
			match => match.status !== 'scheduled'
		)
	}

	get is_matches_complete() {
		return _.size(_.filter(this.get('matches'), ({ status }) => status !== 'complete')) === 0
	}

	get is_scheduled(){
		return this.get('status') === 'scheduled';
	}

	get is_active() {
		return this.get('status') === 'active';
	}

	get is_complete() {
		return this.get('status') === 'complete';
	}

	get is_bye() {
		return bye_rounds_ids.includes(this.get('id'));
	}

	setOpponents({ squads, match_id }) {
		const { matches } = this.attributes,
			actual_match = this.actual_match,
			selected_match_id = match_id || actual_match.id,
			opponents =  _.map(matches, function(match) {
				const home_squad = squads.get(match.home_squad_id),
					away_squad = squads.get(match.away_squad_id)
				;

				return {
					...match,
					label: `${home_squad.get('name')} V ${away_squad.get('name')}`,
					home_squad: home_squad.toJSON(),
					away_squad: away_squad.toJSON(),
					is_selected: selected_match_id === match.id
				};
			});

		this.set({
			opponents
		});

		return this;
	}

	groupByDate(match){
		return _.mixinDateFormat(match.date, "dddd Do MMMM");
	}

	filterByStatus(matches, status) {
		return _.filter(matches, match => match.status === status)
	}

	isMatchedCompleted(matches) {
		return _.every(matches, match => match.status === 'complete');
	}

	getGroupMatchesByDate(array_matches){

		return _.map(_.groupBy(array_matches, this.groupByDate), (matches, date_label) => {
			const is_live_match_in_day = _.size(this.filterByStatus(matches, 'playing')),
				is_complete = this.isMatchedCompleted(matches);

			if (is_live_match_in_day) {
				date_label = date_label + '- LIVE'
			}

			return {
				date_label,
				is_complete,
				matches
			}
		});
	}

	groupMatchesByDate() {
		const { matches } = this.attributes;

		return this.getGroupMatchesByDate(_.sortBy(matches, 'date'))
	}

	getPlayerMatch(squad_id) {
		const { matches } = this.attributes;
		const
			bySquadId = match => {
				const squads_id = _.at(match, ['home_squad_id', 'away_squad_id']);

				return squads_id.includes(squad_id);
			};

		return _.find(matches, bySquadId) || {};
	}

	getOpponentVenues({ id, squad_id }) {
		const { matches } = this.attributes;
		const
			bySquadIds = match => {
				const squads_id = _.at(match, ['home_squad_id', 'away_squad_id']);

				return !_.size(_.difference(squads_id, [id, squad_id]));
			};

		return _.find(matches, bySquadIds) || {};
	}

	setMatchDates() {
		const { matches } = this.attributes;
		const updated_matches = _.map(matches, match => {
			const is_live = match.status === 'playing';
			let time = null;

			if (is_live && match.clock && match.clock.s !== -1) {
				time = match.clock.p + ' | ' + this.getReadableDate(match.clock.s);
			}
			return {
				...match,
				game_date: moment(match.date).format('h:mma'),
				is_scheduled: match.status === 'scheduled',
				is_completed: match.status === 'complete',
				is_live,
				time
			}
		});

		this.set({ matches: updated_matches });
		return this;
	}

	getReadableDate(seconds = 0) {
		let min = parseInt(seconds / 60, 10),
			sec = seconds - min * 60;
		if (min < 10) {
			min = '0' + min;
		}
		if (sec < 10) {
			sec = '0' + sec;
		}

		return min + ':' + sec;
	}
}